import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute,Params  } from '@angular/router';
import { FormBuilder, FormGroup, Validators,ReactiveFormsModule } from '@angular/forms';
import {MatSnackBar} from '@angular/material';
import { OrganisationsService } from 'app/_services/organisations.service';

@Component({
  selector: 'app-addeditorganisation-type',
  templateUrl: './addeditorganisation-type.component.html',
  styleUrls: ['./addeditorganisation-type.component.scss']
})
export class AddeditorganisationTypeComponent implements OnInit {
  errorMessage: string;
  orgTypeForm:FormGroup; 
  productLoading:Boolean=false
  orgTypeFormSubmitted = false;
  utoken:string = localStorage.getItem("utoken");
  usermasterid:any = localStorage.getItem("user_master_id");
  orgTypeId:any = "";
  constructor(
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private orgService:OrganisationsService,
    private router: Router,
    private snackbar:MatSnackBar,
  ){
    this.activatedRoute.params.subscribe((params) => {
      if(params.orgtype_id != "" && params.orgtype_id != undefined){
        this.orgTypeId = params.orgtype_id;
        this.getOrgTypeDetails();
      }
    })
  }

  ngOnInit() {
    this.orgTypeForm = this.formBuilder.group({
      orgType:['',[Validators.required]],
      orgTypeStatus:['Active',[Validators.required]],
    }); 
  }

  getOrgTypeDetails(){
    if(this.orgTypeId != ""){
      this.orgService.getOrganisationTypeDetails(this.orgTypeId).subscribe((response)=>{
        if(response.status_code == "200"){
          this.orgTypeForm.controls['orgType'].setValue(response.Data[0].service_type);
          this.orgTypeForm.controls['orgTypeStatus'].setValue(response.Data[0].status);
        }
      })
    }
  }

  OnSubmit(){
    this.orgTypeFormSubmitted = true;
    if(this.orgTypeForm.invalid){
      return;
    }

this.productLoading=true

    this.orgService.addEditOrganisationType(this.orgTypeForm,this.orgTypeId).subscribe((response)=>{
      if(response.status_code == 200){

        this.productLoading=false
        this.snackbar.open("Organisation Service Type created/updated successfully", 'close', {
          duration: 3000,
          verticalPosition:"top",
          extraClasses: ['bg-green']
        });
        setTimeout(() => {
            this.router.navigate(['/organisation-type']);
        }, 4000);
      }else{
        this.productLoading=false
        this.snackbar.open(response.Metadata.Message, 'close', {
          duration: 3000,
          verticalPosition:"top",
          extraClasses: ['bg-red']
        });
      }
    })
  }
}




// WEBPACK FOOTER //
// ./src/app/component/addeditorganisation-type/addeditorganisation-type.component.ts